import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '../Button';

import {
    AsideExpendBody,
    AsideExpendHead,
    AsideExpend as AsideExpendDiv,
} from './BuilderAside.sc';

const AsideExpend = React.forwardRef((props, ref) => {
    const { title, close, children } = props;
    return (
        <AsideExpendDiv ref={ref}>
            <AsideExpendHead>
                <strong>{title}</strong>
                <Button type="link" onClick={close}>
                    <FontAwesomeIcon icon={['far', 'times']} />
                </Button>
            </AsideExpendHead>
            <AsideExpendBody>{children}</AsideExpendBody>
        </AsideExpendDiv>
    );
});

export default AsideExpend;
